<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Select Node</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-row class="h-100">
          <mdb-col col="6" class="h-100">
            <bridge8-select-list
              class="ml-2 mr-2 h-100"
              entity="label"
              :options="labels"
              label="Node Label"
              :search="true"
              @selected="label = $event"
            />
          </mdb-col>
          <mdb-col col="6" class="h-100">
            <bridge8-select-list
              class="ml-2 mr-2 h-100"
              :options="nodes"
              entity="node"
              label="Node Entity"
              :text-callback="obj => obj.name || (obj.created ? formatDateTime(obj.created) : null) || '--- n/a ---'"
              :search="true"
              :value="node"
              @selected="node = $event"
            />
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        :disabled="!node"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(node)"
        title="Select node"
      >Select</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from 'mdbvue'
import Bridge8SelectList from './Bridge8SelectList'
import {formatDT, errorCatch} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'AdminSelectNodeModal',
  data () {
    return {
      labels: [],
      label: null,
      nodes: [],
      node: null,
      show: false,
      callback: node => { console.log('Node selected: ', Object.assign({}, node)) }
    }
  },
  methods: {
    ...mapActions(['apiGetLabels', 'apiGetNodes']),
    formatDateTime (dtObj) {
      return formatDT(dtObj)
    },
    close (node = null) {
      this.show = false
      if (node && typeof node === 'object') {
        this.callback(node)
      }
      this.label = null
      this.nodes = []
      this.node = null
      this.callback = node => { console.log('Node selected: ', Object.assign({}, node)) }
    }
  },
  mounted () {
    this.$bus.$on('admin-modal-select-node', callback => {
      this.callback = callback
      this.show = true
    })
    this.apiGetLabels().then(labels => { this.labels = labels })
      .catch(errorCatch('Get Labels failed in Select Node Modal', this))
  },
  beforeDestroy () {
    this.$bus.$off('admin-modal-select-node')
  },
  watch: {
    label (newVal, oldVal) {
      if (newVal === null) {
        this.nodes = []
        return
      }
      if (newVal !== oldVal) {
        this.apiGetNodes(newVal).then(nodes => { this.nodes = nodes })
          .catch(errorCatch('Get Nodes failed in Select Node Modal', this))
      }
    }
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    Bridge8SelectList
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/AdminSelectNodeModal.vue